export const frontendSkills = [
  "Semantic & accessible HTML",
  "Responsive Web Design",
  "JavaScript: ES6+",
  "Styled-components",
  "CSS Flexbox",
  "CSS Grid",
  "Promises, Async/Await",
  "Error handling",
  "Debugging",
  "Git",
  "GitHub Pull Request & Review",
  "NPM",
  "Markdown",
  "React",
  "React Router",
  "Redux (toolkit)",
  "Redux-Saga",
  "Working with API (fetch, axios)",
  "REST API",
  "Node.js",
  "Express.js"
];

export const dataSkills = [
  "Python",
  "Conda / Anaconda",
  "Jupyter Notebook / JupyterLab",
  "VS Code",
  "NumPy",
  "Pandas",
  "SQL",
  "EDA",
  "Data profiling",
  "Matplotlib",
  "Seaborn",
  "Plotly",
  "PyDub",
  "Scikit-learn",
  "MLflow",
  "AI models (LLM / Whisper)",
  "Langfuse",
  "Pandera",
  "Streamlit",
  "Streamlit Community Cloud",
  "DigitalOcean",
  "MkDocs",
  "Obsidian",
  "Kanban",
  "Jira",
  "Scrum",
  "Trello",
  "Teamwork"
];